import LazyLoad from "vanilla-lazyload"

(function() {
  var ll = new LazyLoad({
    elements_selector: ".lazy"
  })
})()